module.exports = __webpack_public_path__ + "img/carbon6.82a47571.png";